import { ScanSearch, LayoutDashboard, Scale, Lock, PenLine, MessagesSquare } from "lucide-react";
import { Reveal, SectionLabel, TopWave } from "./shared";
import { useLang } from "./i18n";

const ICONS = [ScanSearch, LayoutDashboard, Scale, Lock, PenLine, MessagesSquare];
const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7", "lg:col-span-6", "lg:col-span-6"];

export function Platform() {
  const { t } = useLang();
  return (
    <section id="platform" className="relative bg-paper py-24 md:py-36">
      <TopWave fill="#F7F9FB" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>{t.platform.label}</SectionLabel>
          <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-[-0.02em] text-ink md:text-5xl">
            {t.platform.titleA} <span className="italic text-aqua-700">{t.platform.titleB}</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-12">
          {t.platform.features.map((f, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={(i % 2) * 0.08} className={`md:col-span-1 ${SPANS[i]}`}>
                <div
                  data-testid={`feature-card-${i}`}
                  className="group h-full rounded-3xl border border-slate-200 bg-white p-8 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:border-aqua-600/30 hover:shadow-[0_20px_56px_rgba(15,27,45,0.08)]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-navy text-aqua-300 transition-transform duration-300 group-hover:scale-110">
                    <Icon size={20} />
                  </span>
                  <h3 className="mt-6 font-display text-xl font-semibold text-ink">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-500">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
